import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Renders the spinner.
 */
export const Spinner = () => (_jsx("div", { className: "searching-spinner", style: { display: "flex", alignItems: "center", justifyContent: "center", padding: "1rem", width: "100%" }, children: _jsx("svg", { width: '32', height: '32', stroke: '#0063a3', viewBox: '0 0 32 32', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("g", { className: 'modus-spinner', children: _jsx("circle", { cx: '16', cy: '16', r: '14.5', fill: 'none', strokeWidth: '3' }) }) }) }));
